import requestCtxs from '@/sealFilter/requestCtxs'



// 针对IP段免登录及第三方认证，生成完整的账号、角色、权限
export function roleAuth (data) {
    return requestCtxs({
        url: '/system/ttv3/manage/system/user/info/add/user/role/auth',
        method: 'post',
        data
    })
}

// 读者用户登陆，自动登录接口
export function autoLogin (data) {
    return requestCtxs({
        url: '/auth/ttv3/security/core/user/reader/auto/login',
        method: 'post',
        data
    })
}

// 读者用户登陆，自动登录接口
export function infoLogin (data) {
    return requestCtxs({
        url: '/system/ttv3/manage/system/user/info/check/auto/login',
        method: 'post',
        data
    })
}


export function validity(data) {
    return requestCtxs({
        url: '/task/ttv3/task/local/mirror/validity/inspect',
        method: 'post',
        data
    })
}

//判断模块显示权限
export function setConfig(data) {
    return requestCtxs({
        url: '/auth/ttv3/security/core/org/security/config',
        method: 'post',
        data
    })
}

//判断机构登录几种方式
export function orgLoginType(data) {
    return requestCtxs({
        url: '/auth/ttv3/security/core/org/login/type/list',
        method: 'post',
        data
    })
}

//背景图列表
export function bgImgList(data) {
    return requestCtxs({
        url: '/portal/ttv3/portal/backgroundInfo/query/bypage',
        method: 'post',
        data
    })
}
//修改背景图片
export function updateBgImg(data) {
    return requestCtxs({
        url: '/portal/ttv3/portal/backgroundInfo/update',
        method: 'post',
        data
    })
}
//退出登录
export function logout(data) {
    return requestCtxs({
        url: '/portal/ttv3/security/core/user/logout',
        method: 'post',
        data
    })
}



// WEBPACK FOOTER //
// ./src/api/user.js